import CRUDService from './CRUDService';

interface AdminFeatureFlag {
  id: string;
  author?: string;
  createdAt?: string;
  description?: string;
  groups: string[];
  history: {
    author: string;
    groups: string[];
    percentage: number;
    updatedAt: string;
    users: string[];
  }[];
  name: string;
  options: object;
  percentage: number;
  updatedAt?: string;
  users: string[];
  usersListDisplay: string[];
}

type AdminFeatureFlags = AdminFeatureFlag[];

export type {AdminFeatureFlags, AdminFeatureFlag};
export default new CRUDService<AdminFeatureFlag>('/v1/admin/feature-flags');
